document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.fireworks');
  if (!container) return;

  if (typeof Fireworks === 'undefined' || !Fireworks.default) {
    console.error('fireworks-js library not loaded');
    return;
  }

  window._headerFireworks = window._headerFireworks || new Fireworks.default(container, {
    hue: { min: 20, max: 340 },
    gravity: 0.8,
    particles: 120,
    explosion: 45,
    trace: 10,
    brightness: { min: 60, max: 100 },
    boundaries: {
      x: 0,
      y: 0,
      width: window.innerWidth,
      height: window.innerHeight
    },
    sound: { enabled: false }
  });

  function burstRealFireworks() {
    const fireworks = window._headerFireworks;
    if (!fireworks) return;
    fireworks.launch();
    setTimeout(() => fireworks.launch(), 300);
    setTimeout(() => fireworks.launch(), 600);
    setTimeout(() => fireworks.stop(), 1800);
  }

  // Static buttons
  document.querySelectorAll('button.button--addToCart[data-buy-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      console.log('🔥 BoosterTheme Add to Cart button clicked!');
      setTimeout(burstRealFireworks, 300);
    });
  });

  // Dynamic buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button.button--addToCart[data-buy-button]');
    if (btn) {
      setTimeout(burstRealFireworks, 300);
    }
  });
});
